import{useContext as o}from"react";import{CookiesContext as r}from"../../libs/cookie/cookiesContext.js";function t(t){const e=o(r);if(!e)throw new Error("Missing <CookiesProvider>");return t?[e.get(t)]:[e.getAll()]}export{t as useCookies};
//# sourceMappingURL=useCookies.js.map
